<mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
<div class="modal-pesos container-fluid d-flex border-bottom">
  <div class="row mr-auto">
    <div class="col-md-12">
      <h3>Pesos do CTE - {{dados.filialEmissaoDescricao}} #{{dados.numCTE}} - Peso Válido: {{dados.peso || 'Não informado'}}</h3>
    </div>
</div>
<mat-icon class="ml-auto" mat-dialog-close="cancel" [hidden]="!dados.isModal">close</mat-icon>
</div>
<div class="table-responsive container-fluid no-padding" [hidden]="isLoading || !grid || grid.data.length == 0">
  <table mat-table [hidden]="isLoading" [dataSource]="grid">
    <ng-container matColumnDef="nrt">
      <th mat-header-cell *matHeaderCellDef> NRT </th>
      <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('nrt', i)"
        [style.display]="getRowSpan('nrt', i) ? '' : 'none'"> {{grid.nrt}} </td>
    </ng-container>
    <ng-container matColumnDef="dtRecep">
      <th mat-header-cell *matHeaderCellDef> Dt. Recepção </th>
      <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('dtRecep', i)"
        [style.display]="getRowSpan('dtRecep', i) ? '' : 'none'"> {{grid.dtRecep | date: 'dd/MM/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="doc">
      <th mat-header-cell *matHeaderCellDef> Documento </th>
      <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('doc', i)"
        [style.display]="getRowSpan('doc', i) ? '' : 'none'"> {{grid.doc}} </td>
    </ng-container>
    <ng-container matColumnDef="nFiscal">
      <th mat-header-cell *matHeaderCellDef> Nota Fiscal </th>
      <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('nFiscal', i)"
        [style.display]="getRowSpan('nFiscal', i) ? '' : 'none'"> {{grid.nFiscal}} </td>
    </ng-container>
    <ng-container matColumnDef="pesoNFiscal">
      <th mat-header-cell *matHeaderCellDef> Peso N. Fiscal (kg) </th>
      <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('pesoNFiscal', i)"
        [style.display]="getRowSpan('pesoNFiscal', i) ? '' : 'none'"> {{grid.pesoNFiscal}} </td>
    </ng-container>
    <ng-container matColumnDef="vol">
      <th mat-header-cell *matHeaderCellDef> Volume </th>
      <td mat-cell *matCellDef="let grid; let i = index" [attr.rowspan]="getRowSpan('vol', i)"
        [style.display]="getRowSpan('vol', i) ? '' : 'none'"> {{grid.vol}} </td>
    </ng-container>
    <ng-container matColumnDef="fonte">
      <th mat-header-cell *matHeaderCellDef>Fonte</th>
      <td mat-cell *matCellDef="let grid" matTooltip="{{grid.fonte}} - {{grid.tipoPeso}}">
        {{ grid.fonte }}
      </td>
    </ng-container>
    <ng-container matColumnDef="bruto">
      <th mat-header-cell *matHeaderCellDef>Bruto (kg)</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.bruto === null || 0 ? '-' : grid.bruto }}
      </td>
    </ng-container>
    <ng-container matColumnDef="cubado">
      <th mat-header-cell *matHeaderCellDef>Cubado (kg)</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.cubado === null || 0 ? '-' : grid.cubado }}
      </td>
    </ng-container>
    <ng-container matColumnDef="cubado_calculado">
      <th mat-header-cell *matHeaderCellDef>Cubado Calculado (kg)</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.cubadoCalculado === null || 0 ? '-' : grid.cubadoCalculado}}
      </td>
    </ng-container>
    <ng-container matColumnDef="dtPesagem">
      <th mat-header-cell *matHeaderCellDef>Data Pesagem</th>
      <td mat-cell *matCellDef="let grid">
        {{ grid.dtPesagem | date:'dd/MM/yyyy hh:mm:ss'}}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<app-paginacao *ngIf="grid && grid.data.length > 0" [pageIndex]="paging?.index" [pageSize]="paging?.size"
  [length]="paging?.length" (page)="onPageChange($event)" [pageSizeOptions]="[5, 10, 15]"></app-paginacao>
<div class="align-footer">
  <button mat-stroked-button type="button" [hidden]=" grid.data.length == 0" (click)="downloadExcel()"
    [disabled]="isLoadingDownload">
    <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
      <mat-spinner diameter="20" color="dark"></mat-spinner>
      &nbsp; Baixando
    </span>
    <span *ngIf="!isLoadingDownload">
      <i class="fas fa-file-excel"></i> Download Excel
    </span>
  </button>
</div>
<div *ngIf="!isLoading && grid && grid.data.length == 0" class="d-flex justify-content-center align-items-center"
  style="height: 100px;">
  Nenhum registro encontrado!
</div>

<div class="modal-actions" [hidden]="!dados.isModal" mat-dialog-actions align="end">
  <button mat-flat-button color="info" mat-dialog-close="cancel">
    Fechar
  </button>
</div>